import { render } from "./EmployeePositionInfo.vue?vue&type=template&id=2c6fd4a1"
import script from "./EmployeePositionInfo.vue?vue&type=script&lang=js"
export * from "./EmployeePositionInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__